"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATTACHMENT_EXTS_ALLOWED = exports.MAX_ATTACHMENT_SIZE = exports.InquiryStatus = void 0;
var InquiryStatus;
(function (InquiryStatus) {
    InquiryStatus["RESOLVED"] = "RESOLVED";
    // creditor waiting by response
    InquiryStatus["WAITING_FOR_RESPONSE"] = "WAITING_FOR_RESPONSE";
    // admin waiting by response
    InquiryStatus["WAITING_FOR_INTERACTION"] = "WAITING_FOR_INTERACTION";
})(InquiryStatus = exports.InquiryStatus || (exports.InquiryStatus = {}));
exports.MAX_ATTACHMENT_SIZE = 5 * 1024 * 1024; // 5MB
exports.ATTACHMENT_EXTS_ALLOWED = ['pdf', 'jpeg', 'png', 'jpg'];
